import { lazy } from "react";
import { getRoute } from "util/react";

const HomeRoute = getRoute(
  {
    fullPath: "/:locale?/",
  },
  "",
  lazy(() => import("./index")),
  null,
);

export default HomeRoute;
